var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"color":"info","outlined":_vm.outlined,"small":_vm.small,"fab":_vm.fab,"text":_vm.text},on:{"click":_vm.back}},[_c('v-icon',[_vm._v(_vm._s(_vm.typeIcon ? _vm.typeIcon : 'mdi-arrow-left'))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }